<template>
	<div class="ToAudit">
		<div class="mask" v-show='maskFlag'>
			<div class="mask-box">
				<div class="mask-top">
					批量导入
					<span @click='Shutdown'>x</span>
				</div>
				<div class="mask-content">
					<p>① 您需先创建企业批量数据导入的模版，</p>
					<p>点击 <span>下载Excel模版</span> </p>
					<p>② 如果您已按照要求整理企业批量数据则在下方直接导入</p>

					<el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>

				</div>
				<div class="mask-button">
					<div>
						<el-button @click='Shutdown'>取消</el-button>
						<el-button type='primary' @click='hangdOK'>确定</el-button>
					</div>

				</div>
			</div>
		</div>
		<div class="cToAudit-top">
			<HeadCom :title='title'></HeadCom>
		</div>

		<div class="cToAudit">
			<div class="cToAudit-box">
				<el-row >
					<el-col :span="6" class="box">
						<span class="institutionsCode">企业名称：</span>
						<el-input v-model="searchValue.enterpriseName" placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="6" class="box">
						<span class="institutionsCode">社会信用代码：</span>
						<el-input v-model="searchValue.creditCode" placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="6" class="box">
						<span class="institutionsCode">法人姓名：</span>
						<el-input v-model="searchValue.legalName" placeholder="请输入内容"></el-input>
					</el-col>
                    <el-col class="auto-btn" :span="6" v-if="userInfo.userType == 2 && userInfo.sonFlag == 0 && title == '投标人待审核' ">
                    <!-- <el-col :span="6" v-if="userInfo.userType == 2 && title == '投标人待审核' "> -->
                        <span class="autoClass">自动审核关联协议状态：</span>
                        <el-radio-group v-model="openAutoCheck" @change='autoChange'>
                            <el-radio :label="1">开</el-radio>
                            <el-radio :label="0">关</el-radio>
                        </el-radio-group>
                    </el-col>
                    <el-col :span="6" class="box" v-if="userInfo.userType == 2 && showChannelSearch">
                        <span>注册渠道：</span>
                        <el-select class="selectClass" v-model="searchValue.channel" clearable filterable placeholder="请选择" style="width:100%;">
                            <el-option v-for="(item,index) in getChannelOptions" :key="index" :label="item" :value="index">
                            </el-option>
                        </el-select>
                    </el-col>
					<el-col :span='18' v-if="userInfo.userType == 2  && title == '投标人已审核' ">
						<el-form class="QueryButton-form">
                            <div class="check-time">
                                <el-form-item label="审核时间：" label-width="var(--inputLabelWidth)">
                                    <el-date-picker v-model="searchValue.startApprovalDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期"
                                        :picker-options="pickerOptionsEnd" clearable >
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="searchValue.endApprovalDate" type="datetime" :picker-options="pickerOptionsEnd" value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择结束日期" placeholder-style='font-size:12px' clearable >
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="checkGropClass" >
                                <el-checkbox-group v-model="latelyIndex" @change="handleCheckedlately">
                                    <el-checkbox v-model="latelyIndex" v-for='(item,index) in latelyList' :key="item.value" :label="item.value">
                                        {{item.label}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
						</el-form>
					</el-col>
					
					<el-col :span="showBtnType" style='text-align: right;'>
						<el-button class="base-medium-btn" type="primary" @click="searchBtn">查询</el-button>
						<el-button class="base-medium-btn" @click="reset">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<div class="innerBottom">
				<el-table :data="tableData" stripe style="width: 100%" highlight-current-row @current-change="CurrentChange">
					<el-table-column type="index" label="序号" width="60">
					</el-table-column>
					<el-table-column label="申请时间" width="170">
						<template slot-scope="scope">
							<span>{{publicMethed.formatDateTime(new Date(scope.row.createTime))}}</span>
						</template>
					</el-table-column>
					<el-table-column v-if="title.indexOf('待审核') ==-1" label="审核时间" width="170">
						<template slot-scope="scope">
							<span v-if='scope.row.status!=0'>
								{{publicMethed.formatDateTime(new Date(scope.row.reviewTime))}}
								<!-- {{scope.row.approvalDate}} -->
							</span>
						</template>
					</el-table-column>
					<el-table-column v-if="userInfo.userType == 2 && (routerFrom==null|| routerFrom.indexOf('channal') == -1) " width="80"
					 prop="type" label="审核类型">
						<template slot-scope="scope">
							<span v-if="scope.row.type== 1">渠道送审</span>
							<span v-if="scope.row.type== 0">关联</span>
							<span v-if="scope.row.type== 2">武夷山</span>
						</template>
					</el-table-column>
					<el-table-column :prop="item.prop" :label="item.value" :width="item.prop == 'orderStatus'
						||item.prop == 'ensure'
						||item.prop == 'effective'
						||item.prop == 'amount'
						||item.prop == 'guaranteeType' 
						|| item.prop == 'showStatus' 
						|| item.prop == 'legalName' 
						?90
						: (item.prop == 'opreate' ? 120:'')"
					 v-for="(item,index) in tableDateDec" :key='index'>
						<template slot-scope="scope">
							<span style="margin: auto;" class="tableBtn" v-if="item.prop == 'opreate'" @click="open(scope.row)">
								{{scope.row['showStatus'] == '待审核'&& routerFrom != 'approved'
								&&(userInfo.userType ==2 &&(userInfo.sonFlag==0||userInfo.personnel == 1)) ?'审核':'查看详情' }}
							</span>
							<span v-if="item.prop != 'opreate'">
								{{(item.prop == 'reviewTime'&&scope.row[item.prop] == null)?'-':scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
				</el-table>

			</div>
			<div class="pagePart">
				<el-pagination background layout="prev, pager, next,total" :total="totalCount" @current-change="handleCurrentChange"
				 :page-size="10" :current-page="page">
				</el-pagination>
			</div>
		</div>

	</div>
</template>
<script>
	import elSelectCityChose from '@/components/elSelectCityChose/elSelectCityChose.vue'
	import HeadCom from "../../headCom"
	export default {
		components: {
			elSelectCityChose,
			HeadCom
		},
		props: {
			routerFrom: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				latelyList: [{
					value: 0,
					label: '今天'
				}, {
					value: 1,
					label: '昨天'
				}, {
					value: 2,
					label: '最近三天'
				}, {
					value: 6,
					label: '最近7天'
				}],
				latelyIndex: [],
				pickerOptionsEnd: {
					disabledDate(time) {
						return time.getTime() > Date.now()  //如果没有后面的-8.64e7就是可以选择今天的
					},
				},
				openAutoCheck: -1, //  1 开启自动审核   0:关闭自动审核
				// areas: {
				// 	province: '不限',
				// 	city: '不限',
				// 	country: '不限'
				// },E
				title: '投标人待审核',
				certStatus: -1,
				// UserPermissions:'渠道',//判断用户是什么权限 是否展示新建
				maskFlag: false, //批量导入开关
				searchValue: {
					enterpriseName: '',
					creditCode: '',
					legalName: '',
					startApprovalDate: '',
					endApprovalDate: '',
					channel: ''
				},
				channelList: this.channelDec,
				tableDateDec: [{
						prop: 'enterpriseName',
						value: '企业名称'
					}, {
						prop: 'creditCode',
						value: '统一社会信用代码'
					}, {
						prop: 'legalName',
						value: '法人姓名'
					},
					{
						prop: 'showStatus',
						value: '状态'
					}, {
						prop: 'opreate',
						value: '操作'
					}
				],
				// 表格数据
				tableData: [],
				page: 1,
				size: 10,
				totalCount: 0,
			}
		},
		computed: {
			UserPermissions() {
				return this.userInfo.userType == 3
			},
            // 根据不同页面显示按钮的栅格布局份数
            showBtnType(){
                if(this.userInfo.userType == 2 && this.userInfo.sonFlag == 0){
                    if(!this.showChannelSearch){
                        // 渠道管理模块
                        return 6;
                    }
                    if(this.title == '投标人待审核'){
                        return 18;
                    }else if(this.title == '投标人已审核'){
                        return 6;
                    }
                    return 24;
								}
                if(this.userInfo.userType == 2 && this.userInfo.sonFlag == 1){
                    if(!this.showChannelSearch){
                        // 渠道管理模块
                        return 6;
                    }
                    if(this.title == '投标人已审核'){
                        return 6;
                    }
                    return 24;
                }
            },
            // 来源渠道显示的页面(由于投标企业管理和渠道管理共用一个组件，因此需要做判断)
            showChannelSearch(){
                let showIncludeRoutes = ["approved","rejected",null];
                if(showIncludeRoutes.indexOf(this.routerFrom) != -1){
                    //投标企业管理模块
                    return true;
                }else{
                    // 渠道管理模块
                    return false;
                }
            },
            // 过滤后的渠道下拉选项
            getChannelOptions(){
                return this.publicMethed.ownAreasChannel();
            }
		},
		created() {
			this.latelyIndexPre = [] //时间 筛选条件，前一次的选择，
			this.statusList = ['待审核', '审核通过', '已驳回']
			this.autoCheck = 0 //1开启自动 审核   0：关闭自动审核
		},
		watch: {
			userInfo(a, b) {
				if (a != null) {
					this.requestData()
				}
			},
			area(a, b) {
				if (a != null) {
					this.requestData()
				}

			},
			$route(to, from) {
				// 菜单切换需更新数据，但是从详情内部返回，不需要更新数据
				// to.path.split('/')[2]  = 'toAudit'   不走
				// from.path.split('/')[3]  = 'accessDetail' 不走
				// from.path.split('/')[3] != 'accessDetail'
				// debugger
				// if (to.path.split('/')[3] != 'toAudit' || (to.path.split('/')[3] != 'toAudit' && from.path.split('/')[3] !='accessDetail'){
				// if (to.path.split('/')[3] == 'toAudit') {
				// 	this.page = 1;
				// 	this.tableData = [];
				// 	this.requestData();
				// }
			}

		},
		mounted() {
			// 区分投标人 列表和 渠道列表
			if (this.routerFrom == 'approved' || this.routerFrom == 'channalApprovaled') {

				if (this.routerFrom == 'approved') {
					this.certStatus = 1
					this.title = '投标人已审核'
				} else {
					this.title = '渠道已审核'
					this.certStatus = 2
				}

			} else if (this.routerFrom == 'channalApprovaling') {
				this.title = '渠道待审核'
				this.certStatus = 1
			} else if (this.routerFrom == 'channalRejected') {
				this.title = '渠道已驳回'
				this.certStatus = -2
			} else if (this.routerFrom == 'rejected') {
				this.certStatus = 2
				this.title = '投标人已驳回'
			}else if (this.routerFrom == 'guarantee') {
				// this.certStatus = 2
				this.title = '担保函'
			}
			if (this.routerFrom == null) {
				if (this.userInfo.userType == 2) {
					this.certStatus = 6
				} else {
					this.certStatus = 0
				}
			}
			if (this.title == '投标人待审核' && this.userInfo.userType == 2 && this.userInfo.sonFlag == 0) {
				this.findAutoStatus() //查询自动审核状态
			}
			this.requestData()
		},
		methods: {
			// 快捷日期选择并回填手动选择日期
			handleCheckedlately(value) {
				for (let i = 0; i < this.latelyIndexPre.length; i++) {
					if (this.latelyIndex.indexOf(this.latelyIndexPre[i]) != -1) {
						this.latelyIndex.splice(this.latelyIndex.indexOf(this.latelyIndexPre[i]), 1)
					}
				}
				this.latelyIndexPre = this.latelyIndex
				if (this.latelyIndex.length == 0) {
					this.$set(this.searchValue, 'startApprovalDate', '')
					this.$set(this.searchValue, 'endApprovalDate', '') //结束时间是今天
				} else {
					let time = new Date()
					let curdate = this.publicMethed.formatDateTime(new Date(time.setDate(time.getDate() - this.latelyIndex[0])))
					// 回填手动选择日期部分
					let date = curdate.split(' ')[0]
			
					let temEndTime = ''
					if (this.latelyIndex[0] == 1) {
						// 时间为昨天时，结束时间是今天0点
						let temData = this.publicMethed.formatDateTime(new Date())
						temEndTime = temData.split(' ')[0] + ' 00:00:00'
					} else {
						temEndTime = this.publicMethed.formatDateTime(new Date())
					}
					this.$set(this.searchValue, 'startApprovalDate', date + ' 00:00:00')
					this.$set(this.searchValue, 'endApprovalDate', temEndTime)
			
				}
			
			},
			handleCurrentChange(value) {
				this.page = value
				this.requestData()
			},
			requestData() {
				let data = {
					page: this.page,
					size: this.size,
				}
				// 主账号才可以筛选地址,子账号直接按子账号的区域查询
				if (this.userInfo.sonFlag == 0) {
					if (this.area.province != '不限') {
						data['province'] = this.area.province
						if (this.area.city != '不限') {
							data['city'] = this.area.city
							if (this.area.country != '不限') {
								data['area'] = this.area.country
							}
						}
					}
				} else {
					data['province'] = this.userInfo.province
					data['city'] = this.userInfo.city
					data['area'] = this.userInfo.district
				}
				data['enterpriseId'] = this.userInfo.enterpriseId
				// 按照状态查询
				// 模糊查询
				for (let key in this.searchValue) {
					if (this.searchValue[key] != '') {
						data[key] = this.searchValue[key]
					}
				}
				// 渠道管理
				if (this.routerFrom != null && this.routerFrom.includes('channal')) {
					// 查询渠道列表

					if (this.certStatus != 2) {
						data['certStatus'] = this.certStatus
					}
					this.requestAPI.toChannelApprove(data).then((res) => {
						let tem = res.data.content
						for (let i = 0; i < tem.length; i++) {
							if (this.routerFrom != null && this.routerFrom.includes('channal')) {
								tem[i]['showStatus'] = this.certStatus == 1 ? '待审核' : (this.certStatus == -2 ? '已驳回' : '审核通过')
							} else {

								tem[i]['showStatus'] = this.certStatus == 5 ? '待审核' : (this.certStatus == 6 ? '审核通过' : '已驳回')
							}

						}
						this.tableData = res.data.content
						this.totalCount = res.data.totalCount
					})
				} else {

					data['auditStatus'] = this.certStatus
					if (this.userInfo.userType == 3) {
						// 渠道查询投标人列表
						this.requestAPI.channelQuery(data).then((res) => {
							let status = '0'
							this.tableData = res.data.content
							this.totalCount = res.data.totalCount
							// let arr=['待审核','已审核','已驳回']
							if (this.title.indexOf('待审核') != -1) {
								status = '0'
							} else if (this.title.indexOf('已审核') != -1) {
								status = '1'
							} else {
								status = '2'
							}
							for (let i = 0; i < this.tableData.length; i++) {
								this.tableData[i]['showStatus'] = this.statusList[status]
							}

						})
					} else if (this.userInfo.userType == 2) {
						// 担保机构查询投标人列表  有自主注册关联审核，还有渠道送来的审核
						let data1 = {
							page: this.page,
							size: this.size,
							enterpriseId: this.userInfo.enterpriseId,

						}
						// 模糊查询
						for (let key in this.searchValue) {
							if (this.searchValue[key] != '') {
								data1[key] = this.searchValue[key]
							}
						}
						if (this.title.indexOf('待审核') != -1) {
							data1['status'] = '0'
						} else if (this.title.indexOf('已审核') != -1) {
							data1['status'] = '1'
						} else {
							data1['status'] = '2'
						}
						this.requestAPI.getEnterList(data1).then((res) => {
							let tem = res.data.enterpriseList
							for (let i = 0; i < tem.length; i++) {
								tem[i]['showStatus'] = this.statusList[tem[i].status]
							}
							this.tableData = tem
							this.totalCount = res.data.totalCount
						})
					}
				}
			},
			autoChange() {
				//1开启自动 审核   0：关闭自动审核
				this.requestAPI.autoCheckSwitch({
					autoCheck: this.openAutoCheck,
                    enterpriseId: this.userInfo.enterpriseId,
                    type:0
				}).then((res) => {})
			},
			// 查询此担保公司的审核开关状态
			findAutoStatus() {
				this.requestAPI.findAutoCheckStatus({
                    enterpriseId: this.userInfo.enterpriseId,
                    type:0
				}).then((res) => {
                    this.openAutoCheck = Number(res.data)
				})
			},
			searchBtn() {
				this.page = 1
				this.requestData()
			},
			CurrentChange(val) {
				this.currentRow = val;
			},
			reset() {
				for (let key in this.searchValue) {
					this.$set(this.searchValue, key, '')
				}
				this.latelyIndex = []
				this.requestData()
			},
			handleSizeChange() {},
			// 审查
			open(obj) {
				// if(this.userInfo.userType == 2&& typeof obj.type == 'undefined'){
				// 	this.$message.error("此列表信息错误！")
				// 	return 
				// }
				// 当渠道进来，只能查看投标人列表,详情只考虑投标人
				// 担保机构，可能查看自主注册的投标人关联的审核，或者是渠道送来的投标人
				let query = {}
				if (this.userInfo.userType == 2) {
					if (this.routerFrom != null && this.routerFrom.includes('channal')) {
						query['fr'] = 'channal'
						query['id'] = obj.enterpriseId
					} else {
						// type :0 自主注册  1 渠道录入的
						query['fr'] = 'bid'
						query['id'] = obj.enterpriseId
						query['type'] = obj.type
						if (obj.type == 0) {
							query['bgId'] = obj.bgId
						}
						if (obj.type == 2) {
                            query['bgId'] = obj.bgId;
                            query['bidderOrderNo'] = obj.bidderOrderNo;
						}
					}
				} else {
					query['fr'] = 'bid'
					query['id'] = obj.channelId
					query['type'] = 1
				}
				this.$router.push({
					path: '/internalSystem/enterpriseAccess/accessDetail',
					query: query
				})
			},
			//新建投标企业
			newEnter() {
				this.$router.push('/internalSystem/enterpriseAccess/newBiddingEnterprise')
			},
			//关闭批量导入弹框
			Shutdown() {
				this.maskFlag = false
			},
			//打开批量导入
			BulkImport() {
				this.maskFlag = true
			},
			hangdOK() {
				this.maskFlag = false
			}
		}
	}
</script>

<style lang="less" scoped="">
	@import '../index.css';

	.ToAudit {
		width: 100%;
		height: 100%;

		.mask {
			width: 100%;
			height: 1000px;
			background: rgba(0, 0, 0, .5);
			position: fixed;
			z-index: 99;

			// position: relative;
			.mask-box {
				width: 480px;
				height: 510px;
				background: #FFFFFF;
				box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.20);
				border-radius: 4px;
				border-radius: 4px;
				// line-height: 510px;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%,-50%);

				.mask-top {
					width: 100%;
					height: 50px;
					line-height: 50px;
					font-family: PingFangSC-Medium;
					font-size: 16px;
					color: rgba(0, 0, 0, 0.85);
					line-height: 50px;
					border-bottom: 1px solid rgba(0, 0, 0, 0.09);
					padding-left: 20px;
					position: relative;

					span {
						position: absolute;
						right: 40px;
					}
				}

				.mask-content {
					width: 60%;
					margin: 0 auto;

					p {
						font-family: PingFangSC-Regular;
						font-size: 14px;
						color: rgba(0, 0, 0, 0.65);
						text-align: left;
					}

					:nth-child(1) {
						margin-top: 20px;
					}

					:nth-child(2) {
						margin-top: 5px;
						margin-left: 5px;

						span {
							color: #1890ff
						}
					}

					:nth-child(3) {
						margin-top: 20px;
					}

					.el-upload--text {
						width: 100%;
					}

					/deep/.el-upload-dragger {
						width: 271px;
						height: 160px;
					}
				}

				.mask-button {
					border-top: 1px solid #ccc;
					width: 100%;
					height: 50px;
					position: absolute;
					bottom: 0;
					line-height: 50px;

					div {
						float: right;
						margin-right: 5px;
					}
				}
			}
		}

		.cToAudit-top {
			width: 100%;
			background: #FFFFFF;
			box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
		}

		.cToAudit {
			// width: 95%;
			margin: 0 auto;
			position: relative;
			// min-width: 1240px;
			background: white;
			margin: 20px 20px 0px 20px;
			padding: 15px 15px 0 15px;
			box-sizing: border-box;
			min-height: calc(100vh - 144px);

			.cToAudit-box {
                .el-row{
                    display: flex;
                    flex-wrap: wrap;
                    .el-col{
                         margin: 7px 0;
                        &.box {
                            display: flex;
                            align-items: center;
                            span {
                                font-family: PingFangSC-Regular;
                                font-size: 14px;
                                color: rgba(0, 0, 0, 0.85);
                                width: var(--inputLabelWidth);
                                text-align: right;
                                flex-shrink: 0;
                            }
                        }
                        &.auto-btn{
                            text-align: right;
                        }
                    }
                }
			}
            /deep/ .el-radio__inner {
                border: 1px solid #1890FF;
            }

            .QueryButton-form{
                display: flex;
                align-items: center;
                .el-form-item{
                    margin-bottom: 0;
                    /deep/.el-form-item__content{
                        display: flex;
                    }
                }
                .check-time{
                    flex: 2;
                    /deep/.el-form-item__label{
                        padding: 0;
                    }
                    flex-shrink: 0;
                    .el-date-editor{
                        width: calc(50% - 57.5px);
                    }
                }
                .checkGropClass{
                    flex:1;
                    text-align: right;
                    .el-checkbox {
                        margin-right: 10px;
                    }
                }
            }

			.BulkImport {
				margin-top: 60px;
			}

			.scard {
				width: 100%;
				display: flex;
			}

			/deep/ .el-row {
				font-size: 14px;
				display: flex;
                align-items: center;
                
			}

			// /deep/ .el-input--suffix .el-input__inner {
			// 	height: 32px;
			// 	line-height: 32px;
			// }
		}
		.approvalTimeClass{
			display: flex;
			align-items: center;
			/deep/ .el-form-item{
				margin: auto;
			}
		}
		.btnClass {
			display: flex;

			.chongzhiBtn {
				background-color: white;
				color: black;
				border: 1px solid #D9D9D9;
				margin-left: 8px;
			}
		}

		.createNew {
			width: fit-content;
			margin-top: 20px;
			padding: 0 16px;
		}

		.innerBottom {
			padding-top: 15px;
			font-size: 14px;
			// padding-right: 20px;

			/deep/ .el-table thead {
				font-size: 14px;
				color: #333333;
				font-weight: normal;
			}

			min-height: 400px;
			// padding-bottom: 80px;

			.tableBtn {
				margin: auto;
				cursor: pointer;
				font-size: 14px;
				color: #1890FF;
				margin-right: 11px;
			}
		}

		.pagePart {
			// position: absolute;
			// bottom: 40px;
            // right: 21px;
            padding: 15px 0;
            text-align: right;
		}
	}
</style>
